module.exports = require('./helpers/bundle-url').getBundleURL('iX4Xl') + "annotation-severity-critical-icon.c8c3531f.svg";